import { render, staticRenderFns } from "./OtherParentingArrangements.vue?vue&type=template&id=5667badc"
import script from "./OtherParentingArrangements.vue?vue&type=script&lang=ts"
export * from "./OtherParentingArrangements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports